import React from "react";
import TaskIcon from "@mui/icons-material/Task";
import EditIcon from "@mui/icons-material/Edit";

function EditButtonMobile(props) {
  return (
    // <div
    //   className="square-button-mobile check-button-color centered-content button-pointer"
    //   title="Edit"
    //   onClick={props.handleOpen}
    // >
    //   <EditIcon style={{ fontSize: 18, color: "white" }} />
    //   {/* <span className="tooltip-text">{props.title}</span> */}
    // </div>

    <div
      title={props.title || "Edit"}
      role="button"
      tabIndex={0}
      onClick={(e) => {
        if (props.onClick) return props.onClick(e);
        if (props.handleOpen) return props.handleOpen(e);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (props.onClick) return props.onClick(e);
          if (props.handleOpen) return props.handleOpen(e);
        }
      }}
      style={{
        backgroundColor: "#16a34a", // vert
        width: 36,
        height: 36,
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
    >
      <EditIcon style={{ fontSize: 18, color: "white" }} />
    </div>
  );
}

export default EditButtonMobile;
